
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

import { sharedState } from '../../framework/state';
import { ValidationProvider } from 'vee-validate';
import { getFieldNameFromVModelProperty } from '../../framework/util/component_util';

@Component({
    components: { ValidationProvider },
})
export default class UsageField extends Vue {
    @Prop(String) readonly name!: string;
    @Prop(Number) readonly value!: number;
    @Prop(Boolean) readonly readonly!: string;
    @Prop(Boolean) readonly required!: boolean;
    @Prop(Boolean) readonly horizontal!: boolean;
    @Prop(Boolean) readonly hideLabel!: boolean;
    @Prop(Boolean) readonly disabled!: string;

    shared = sharedState;
    local = {
        value: undefined as number | undefined,
    };

    mounted() {
        this.modelValueChange(this.value);
    }

    @Watch('value')
    modelValueChange(newValue: number) {
        this.local.value = newValue;
    }

    @Watch('local.value')
    inputValueChange(newValue: string | null) {
        if (typeof newValue === 'string' && newValue.length === 0) {
            this.$emit('input', undefined);
        }

        const numberValue =
            typeof newValue !== 'undefined' && newValue !== null && newValue.length > 0
                ? parseFloat(newValue)
                : undefined;
        if (typeof numberValue !== 'undefined') {
            this.$emit('input', numberValue);
        }
    }

    getFieldLabel(): string {
        if (this.hideLabel) {
            return '';
        } else {
            return this.$t(this.getFieldName() ? 'field.' + this.getFieldName() : '').toString();
        }
    }

    getFieldName() {
        return getFieldNameFromVModelProperty(this);
    }
}
